import DetailsHeader from 'app/components/common/reports/DetailsHeader'

import { ProductTypesSimple } from './product-types-simple'
import { ProductTypesSplitted } from './product-types-splitted'
import { PaymentMethodsDto, ProductDataDto, ProductDataTotalDto } from './types'

type Props = {
  splitByDays: boolean
  productTypes: ProductDataDto
  total: ProductDataTotalDto
  paymentMethods: PaymentMethodsDto
}

export const ProductTypes = ({ splitByDays, productTypes, total, paymentMethods }: Props) => {
  return (
    <>
      <DetailsHeader reportTitle="Продажи" />
      {splitByDays ? (
        <ProductTypesSplitted
          productTypes={productTypes}
          total={total}
          paymentMethods={paymentMethods}
        />
      ) : (
        <ProductTypesSimple
          productTypes={productTypes}
          total={total}
          paymentMethods={paymentMethods}
        />
      )}
    </>
  )
}
